import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
export default function useMounted(didMount) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      mounted = _useState2[0],
      setMounted = _useState2[1];

  useEffect(() => {
    setMounted(true);
  }, []);
  useEffect(() => {
    if (didMount && !mounted) {
      didMount();
    }
  }, [didMount, mounted]);
  return mounted;
}